import { createApp } from 'vue'
import discardVue from './index.vue'


const buttons = ['confirm', 'prompt']

const discardMessage = function (options) {
  return new Promise((resolve, reject) => {
    const app = createApp(discardVue, {
      ...options,
      onDestroy: () => {
        app.unmount()
      },
      onOK: (value) => {
        resolve(value)
      },
      onCancel: (value) => {
        reject(value)
      }
    })

    const frg = document.createDocumentFragment()
    app.mount(frg)
    document.body.appendChild(frg)
  })
}

export default discardMessage
